import { forwardRef, type SVGProps } from 'react';

export interface CreditIconProps extends Omit<SVGProps<SVGSVGElement>, 'css'> {}

export const CreditIcon = forwardRef<SVGSVGElement, CreditIconProps>((props, ref) => (
  <svg ref={ref} {...props} aria-hidden="true" fill="none" viewBox="0 0 16 16">
    <path
      d="M12.5 8C12.5 5.51474 10.4853 3.5 8 3.5C5.51474 3.5 3.5 5.51474 3.5 8C3.5 10.4853 5.51474 12.5 8 12.5C10.4853 12.5 12.5 10.4853 12.5 8ZM13.5 8C13.5 11.0375 11.0375 13.5 8 13.5C4.96246 13.5 2.5 11.0375 2.5 8C2.5 4.96246 4.96246 2.5 8 2.5C11.0375 2.5 13.5 4.96246 13.5 8Z"
      fill="currentColor"
    />
    <path
      d="M6.56641 9.48085L8.56641 6.01675C8.70448 5.77761 9.01027 5.69567 9.24942 5.83374C9.48857 5.97181 9.5705 6.27761 9.43243 6.51675L7.43243 9.98085C7.29436 10.22 6.98857 10.3019 6.74942 10.1639C6.51027 10.0258 6.42833 9.72 6.56641 9.48085Z"
      fill="currentColor"
    />
  </svg>
));

CreditIcon.displayName = 'CreditIcon';
